import { gql } from '@apollo/client'
import { PAYMENT_METHOD } from 'lib/core/resources/constants'

export const affirmConfigQuery = gql`
  query {
    affirmConfig {
      api_key_public
      api_url
      info
      logo_src
      pwa_url
      script
    }
  }
`

export interface AffirmConfig {
  api_key_public: string
  api_url: string
  info: string
  logo_src: string
  pwa_url: string
  script: string
}

export const setPaymentMethodOnCartMutation = gql`
  mutation setPaymentMethodOnCart(
    $cartId: String!
    $checkoutToken: String!
  ) {
    setPaymentMethodOnCart(
      input: {
        cart_id: $cartId,
        payment_method: {
          code: "${PAYMENT_METHOD.AFFIRM}"
          affirm: {
            checkout_token: $checkoutToken
          }
        }
      }
    ) {
      cart {
        selected_payment_method {
          code
          title
        }
      }
    }
  }
`

export interface SetPaymentMethodOnCartResponse {
  setPaymentMethodOnCart: {
    cart: {
      selected_payment_method: {
        code: string
      }
    }
  }
}
